import { render } from "./App.vue?vue&type=template&id=e6c15434&lang=pug&bindings={\"modalStatus\":\"setup\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=postcss"
script.render = render

export default script